import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

export default function Shell({ children }) {
  const { admin, signOut } = useAdminAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Auto-close the mobile drawer whenever the route changes, so tapping a nav
  // link doesn't leave the drawer hanging open on top of the new page.
  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  // Editors see ONLY products. Everything else (orders, coupons, analytics,
  // categories, assets, curated lists, user management) is admin-only and
  // hidden from the nav entirely. App.js's Gate also redirects editors away
  // from those routes if they try to navigate directly.
  const isEditor = admin?.role === 'editor';

  return (
    <div className={`admin-shell${sidebarOpen ? ' sidebar-open' : ''}`}>
      <aside className="admin-sidebar">
        <div className="brand">IT'S A SIMCHA ADMIN</div>
        <nav>
          {!isEditor && <NavLink end to="/">Dashboard</NavLink>}
          <div className="group">Catalog</div>
          <NavLink to="/pages/products">Products</NavLink>
          <NavLink to="/pages/createProduct">New Product</NavLink>
          {!isEditor && <NavLink to="/pages/categories">Categories</NavLink>}
          {!isEditor && <NavLink to="/pages/filters">Filters</NavLink>}
          {!isEditor && <NavLink to="/pages/autofillableFields">Autofillable Fields</NavLink>}
          {!isEditor && <NavLink to="/pages/fieldLayoutPresets">Field Layout Presets</NavLink>}
          {!isEditor && <>
            <div className="group">Assets</div>
            <NavLink to="/pages/fontsList">Fonts</NavLink>
            <NavLink to="/pages/saveFonts">Upload Font</NavLink>
            <NavLink to="/pages/watermarks">Watermarks</NavLink>
            <NavLink to="/pages/brandingLogo">Branding Logo</NavLink>
            <NavLink to="/pages/songs">Songs</NavLink>
            <div className="group">Curated lists</div>
            <NavLink to="/pages/halls">Halls</NavLink>
            <NavLink to="/pages/shuls">Shuls</NavLink>
            <NavLink to="/pages/peopleNames">People Names</NavLink>
            <div className="group">Commerce</div>
            <NavLink to="/pages/coupons">Coupons</NavLink>
            <NavLink to="/pages/OrderList">Orders</NavLink>
            <NavLink to="/pages/analytics">Analytics</NavLink>
            <NavLink to="/pages/adLinks">Ad Links</NavLink>
            <div className="group">System</div>
            <NavLink to="/pages/adminUsers">Users</NavLink>
            <NavLink to="/pages/system-logs">System Logs</NavLink>
          </>}
        </nav>
      </aside>
      <div
        className="admin-sidebar-backdrop"
        onClick={() => setSidebarOpen(false)}
        aria-hidden="true"
      />
      <main className="admin-main">
        <div className="admin-topbar">
          <button
            type="button"
            className="admin-menu-btn"
            onClick={() => setSidebarOpen(v => !v)}
            aria-label="Toggle navigation"
          >
            <span /><span /><span />
          </button>
          <div className="user">
            <span className="user-email">{admin?.email}</span>
            <button className="btn small secondary" style={{ marginLeft: 10 }} onClick={signOut}>Sign out</button>
          </div>
        </div>
        {children}
      </main>
    </div>
  );
}
